import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'ert-study-metric-info',
  templateUrl: './study-metric-info.component.html',
  styleUrls: ['./study-metric-info.component.scss']
})
export class StudyMetricInfoComponent implements OnInit {

  @Input() protocolNo: string;
  @Input() metricName: string;
  @Input() metricThreshold: string;
  @Input() studyName: string;
  @Input() category: string;
  @Input() valueMinMax: string;
  @Input() metricWeight: string;
  @Input() metricValue: string;

  constructor() { }

  ngOnInit() {
  }

}
